import React from 'react';
import { Route } from 'react-router';
import { ProductPageBreadCrumb } from '../Common/BreadCrumb';
import Editor, { willHideOnEditor } from '../Common/Editor/Editor';
import { withBlockingFetchStoreOnMount } from '../Common/Providers/WithStoreDetail';
import Modal from '../Common/Modal';
import Auth from '../Auth/index';
import EditorModule from '../remoteContent/EditorModule';
import CategoryPage from '../Common/Editor/CategoryPage';

const BreadCrumb = willHideOnEditor(ProductPageBreadCrumb);

const PageLayout = props => (
  <div>
    {props.breadcrumb}
    {props.content}
  </div>
);

const wrapper = (props) => {
  return (user) => {
    const {
      state,
      data: {
        code: storeCode,
        currency: {
          code
        } = {}
      } = {}
    } = user.store;

    const {
      location: {
        query: {
          projectId = null
        }
      }
    } = user;

    return (
      <span>
        <Modal modalId="editor-login" size="md">
          { closeModal =>(
            <Auth
              onTokenUpdate={() => { return }}
              closeModal={closeModal}
              isFromEditor={true} />
          )}
        </Modal>
        <CategoryPage {...props}/>
        <Editor
          currency={code}
          storeName={storeCode}
          {...props}
          {...projectId && { projectId }}
        />
      </span>
    );
  }
};

const getRoute = (item, index) => {
  return <Route
    key={`${item.friendly_url}-${index}`}
    label={item.display_name || 'noname'}
    path={item.friendly_url === 'home' ? item.friendly_url : `${item.friendly_url}*`}
    components={{
      breadcrumb: BreadCrumb,
      content: withBlockingFetchStoreOnMount(wrapper({
        ...item.product_family_id && { productFamilyId: item.product_family_id },
        ecommerceUrlPart: `${window.location.protocol}//${window.location.host}/${item.friendly_url}`,
        moduleId: item.editor_module_id,
        displayName: item.display_name
      }))
    }}>
  </Route>
};

const Routes = (
    <Route component={PageLayout} >
      {
        EditorModule.data.map(getRoute)
      }
    </Route>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes/ProductCategory.js